<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          :confirm="askConfirm"
          :routeBack="this.$store.getters.isAdmin ? 'Dashboard' : 'UserIndex'"
          :title="$t('Add') + ' ' + $t('a')  + ' ' +  (this.$store.getters.isAdmin? $t('client'): $t('collaborator'))"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

              <div v-if="isAdmin" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.personal.infos') }}
                </span>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.firstname.invalidFeedback"
                    :label="$t('user.Firstname')"
                    :state="form.firstname.state"
                    class="medium-label mb-4"
                    label-for="firstname-input">
                    <b-form-input
                      id="firstname-input"
                      v-model="form.firstname.value"
                      :state="form.firstname.state"
                      maxlength="250"
                      placeholder="Prénom"
                      required
                      tabindex="1"
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.lastname.invalidFeedback"
                    :label="$t('user.Lastname')"
                    :state="form.lastname.state"
                    class="medium-label mb-4"
                    label-for="lastname-input">
                    <b-form-input
                      id="lastname-input"
                      v-model="form.lastname.value"
                      :state="form.lastname.state"
                      maxlength="250"
                      placeholder="Nom"
                      required
                      tabindex="2"
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.username.invalidFeedback"
                    :label="$t('user.Username')"
                    :state="form.username.state"
                    class="medium-label mb-4"
                    label-for="username-input">
                    <b-form-input
                      id="username-input"
                      v-model="form.username.value"
                      :state="form.username.state"
                      placeholder="email@email.com"
                      required
                      tabindex="3"
                      type="email"
                      v-on:change="removeInvalidFeedback('username'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.phoneNumber.invalidFeedback"
                    :label="$t('user.PhoneNumber')"
                    :state="form.phoneNumber.state"
                    class="medium-label mb-4"
                    label-for="phoneNumber-input">
                    <b-form-input
                      id="phoneNumber-input"
                      v-model="form.phoneNumber.value"
                      :state="form.phoneNumber.state"
                      maxlength="250"
                      placeholder="0123456789"
                      required
                      tabindex="4"
                      type="text"
                      v-on:change="removeInvalidFeedback('phoneNumber'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <password-creation-field :isEdit="false" :minLength="8" :tab-index="5"
                                           @passwordInfos="handlePasswordInfos"></password-creation-field>
                </div>
                <div v-if="isAdmin" class="col-md-6 mt-4">
                  <b-form-checkbox v-model="form.isLNIGroup.value">
                    {{ $t('user.isLNIGroup') }}
                  </b-form-checkbox>
                </div>
                <div v-else-if="isEstateAgent" class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.typeCollaborator.invalidFeedback"
                    :label="$t('role.enum.type.collaborator')"
                    :state="form.typeCollaborator.state"
                    class="medium-label"
                    label-for="typeCollaborator-input">
                    <b-form-select
                      id="typeCollaborator-input"
                      v-model="form.typeCollaborator.value"
                      :invalid-feedback="form.typeCollaborator.invalidFeedback"
                      :state="form.typeCollaborator.state"
                      required
                      v-on:change="removeInvalidFeedback('typeCollaborator');">
                      <option v-for="option in collaboratorType" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                  <div v-if="form.typeCollaborator.value === 'ROLE_COLLABORATOR'" class="mb-4">
                    {{ $t('role.enum.ROLE_COLLABORATOR.explication') }}
                  </div>
                  <div v-else-if="form.typeCollaborator.value === 'ROLE_COLLABORATOR_PLUS'" class="mb-4">
                    {{ $t('role.enum.ROLE_COLLABORATOR_PLUS.explication') }}
                  </div>
                  <div v-else-if="form.typeCollaborator.value === 'ROLE_AGENT_IMMO'" class="mb-4">
                    {{ $t('role.enum.ROLE_AGENT_IMMO.explication') }}
                  </div>
                </div>
              </div>

              <div v-if="isAdmin" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.entreprise.infos') }}
                </span>
              </div>

              <b-row v-if="isAdmin" class="row mt-4">
                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.entreprise.invalidFeedback"
                    :label="$t('user.Entreprise')"
                    :state="form.entreprise.state"
                    class="mb-4"
                    label-for="entreprise-input">
                    <b-form-input
                      id="entreprise-input"
                      v-model="form.entreprise.value"
                      :state="form.entreprise.state"
                      maxlength="250"
                      placeholder="Entreprise"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.address.invalidFeedback"
                    :label="$t('user.Address')"
                    :state="form.address.state"
                    class="mb-4"
                    label-for="address-input">
                    <b-form-input
                      id="address-input"
                      v-model="form.address.value"
                      :state="form.address.state"
                      maxlength="250"
                      placeholder="Rue de la paix"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-1">
                  <b-form-group
                    :invalid-feedback="form.postalCode.invalidFeedback"
                    :label="$t('user.PostalCode')"
                    :state="form.postalCode.state"
                    class="mb-4"
                    label-for="postalCode-input">
                    <b-form-input
                      id="postalCode-input"
                      v-model="form.postalCode.value"
                      :state="form.postalCode.state"
                      maxlength="5"
                      minlength="5"
                      placeholder="75000"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    :invalid-feedback="form.city.invalidFeedback"
                    :label="$t('user.City')"
                    :state="form.city.state"
                    class="mb-4"
                    label-for="city-input">
                    <b-form-input
                      id="city-input"
                      v-model="form.city.value"
                      :state="form.city.state"
                      maxlength="250"
                      placeholder="Paris"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.capitalSocial.invalidFeedback"
                    :label="$t('user.CapitalSocial')"
                    :state="form.capitalSocial.state"
                    class="mb-4"
                    label-for="capital-input">
                    <b-input-group>
                      <b-form-input
                        id="capital-input"
                        v-model="form.capitalSocial.value"
                        :state="form.capitalSocial.state"
                        maxlength="250"
                        placeholder="10000€"
                        type="text">
                      </b-form-input>
                      <b-input-group-append>€</b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.siret.invalidFeedback"
                    :label="$t('user.Siret')"
                    :state="form.siret.state"
                    class="mb-4"
                    label-for="siret-input">
                    <b-form-input
                      id="siret-input"
                      v-model="form.siret.value"
                      :state="form.siret.state"
                      maxlength="14"
                      minlength="14"
                      placeholder="12345678912345"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.rcs.invalidFeedback"
                    :label="$t('user.Rcs')"
                    :state="form.rcs.state"
                    class="mb-4"
                    label-for="rcs-input">
                    <b-form-input
                      id="rcs-input"
                      v-model="form.rcs.value"
                      :placeholder="$t('user.Rcs.placeholder')"
                      :state="form.rcs.state"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>
              </b-row>

              <div v-if="isAdmin" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.Abonnements') }}
                </span>
              </div>

              <div v-if="displayWarning" class="row mb-3">
                <div class="col-md-12 align-items-center main-red-color">
                  <alert-circle-icon class="mr-1" size="20" style="color: var(--main-red);"></alert-circle-icon>
                  {{ $t('free.account.or.abonnements') }}
                </div>
              </div>


              <div v-for="(abonnement, index) in form.abonnements" :key="index">
                <div class="row align-items-center">
                  <div class="col-md-2">
                    <b-form-group
                      :invalid-feedback="abonnement.debut.invalidFeedback"
                      :label="$t('user.abonnement.debut')"
                      :label-for="`abonnement[${index}][debut]-index`"
                      :state="abonnement.debut.state"
                      class="medium-label mb-4">
                      <datepicker-input
                        :id="`abonnement[${index}][debut]-index`"
                        v-model="abonnement.debut.value"
                        :state="abonnement.debut.state"
                        locale="fr"
                        required
                        v-on:input="manageDates(index, 'debut'); askConfirm=true;">
                      </datepicker-input>
                    </b-form-group>
                  </div>

                  <div class="col-md-2">
                    <b-form-group
                      :invalid-feedback="abonnement.fin.invalidFeedback"
                      :label="$t('user.abonnement.fin')"
                      :label-for="`abonnement[${index}][fin]-index`"
                      :state="abonnement.fin.state"
                      class="medium-label mb-4">
                      <datepicker-input
                        :id="`abonnement[${index}][fin]-index`"
                        v-model="abonnement.fin.value"
                        :min="abonnement.debut.value"
                        :state="abonnement.fin.state"
                        locale="fr"
                        required
                        v-on:input="manageDates(index, 'fin'); askConfirm=true;">
                      </datepicker-input>
                    </b-form-group>
                  </div>

                  <div class="col-md-2">
                    <b-form-group
                      :invalid-feedback="abonnement.maxNbCollaborators.invalidFeedback"
                      :label="$t('user.abonnement.maxNbCollaborators')"
                      :label-for="`abonnement[${index}][maxNbCollaborators]-index`"
                      :state="abonnement.maxNbCollaborators.state"
                      class="medium-label mb-4">
                      <b-form-input
                        :id="`abonnement[${index}][fin]-index`"
                        v-model="abonnement.maxNbCollaborators.value"
                        :min="0"
                        :state="abonnement.maxNbCollaborators.state"
                        required
                        step="1"
                        type="number"
                        v-on:input="askConfirm=true;">
                      </b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-md-2">
                    <b-form-group
                      :invalid-feedback="abonnement.maxNbLots.invalidFeedback"
                      :label="$t('user.abonnement.maxNbLots')"
                      :label-for="`abonnement[${index}][maxNbLots]-index`"
                      :state="abonnement.maxNbLots.state"
                      class="medium-label mb-4">
                      <b-form-input
                        :id="`abonnement[${index}][fin]-index`"
                        v-model="abonnement.maxNbLots.value"
                        :min="0"
                        :state="abonnement.maxNbLots.state"
                        required
                        step="1"
                        type="number"
                        v-on:input="askConfirm=true;">
                      </b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-md-1">
                    <b-button class="show-action-btn delete" size="sm" type="button"
                              @click="clickOnDeleteBtnAbonnement(index)">
                      <trash-icon size="18"/>
                    </b-button>
                  </div>
                </div>
              </div>

              <div v-if="isAdmin" class="row">
                <div class="col-md-12">
                  <span v-if="!form.freeAccount.value" class="bold-text addLink" @click="addAbonnement">
                    + {{ $t('Add') }} {{ $t('user.abonnement') }}
                  </span>
                  <span v-else class="bold-text secondary-text-color">
                    + {{ $t('Add') }} {{ $t('user.abonnement') }}
                  </span>
                </div>
              </div>

              <div v-if="isAdmin" class="row">
                <div class="col-md-12 mt-4">
                  <b-form-checkbox v-model="form.virVefaEnabled.value">
                    {{ $t('Possibilité de créer des opérations de type VIR/VEFA') }}
                  </b-form-checkbox>
                </div>
              </div>

              <div v-if="isAdmin" class="row">
                <div class="col-md-12 mb-3 mt-4">
                  <div class="d-flex mb-2">
                    <span class="medium-text mr-2"> {{ $t('user.Comment') }}</span>
                  </div>
                  <VueEditor id="commentaire-admin" ref="editor"
                             v-model="form.commentaire.value" :editorToolbar="customToolbar"></VueEditor>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <b-button tabindex="5" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import {VueEditor} from "vue2-editor";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";

export default {

  name: 'UserCreate',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField,
    VueEditor,
    DatepickerInput
  },

  data() {
    return {
      isAdmin: this.$store.getters.isAdmin,
      isEstateAgent: this.$store.getters.isEstateAgent,
      userId: this.$route.params.userId,
      askConfirm: false,
      collaboratorType: [],
      abonnementPremiumType: [],
      form: {
        firstname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        entreprise:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        capitalSocial:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        siret:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        rcs:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        password:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        freeAccount:
          {
            state: null,
            invalidFeedback: null,
            value: false
          },
        accessType:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        endAccess:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        typeCollaborator:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        commentaire:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        virVefaEnabled:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        isLNIGroup:
          {
            state: null,
            invalidFeedback: null,
            value: false
          },
        abonnements: []
      },
      showPassword: true,
      displayWarning: false,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        ['blockquote', 'code-block'],
        [{list: "ordered"}, {list: "bullet"}],
      ],
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    handlePasswordInfos(state, invalidFeedback, value) {
      this.form.password.state = state
      this.form.password.invalidFeedback = invalidFeedback
      this.form.password.value = value
    },


    async fetchData() {
      this.getCollaboratorType()
    },

    getCollaboratorType() {
      if (this.isEstateAgent) {
        api
          .get(`/user/getCollaboratorTypes`)
          .then(response => {
            this.collaboratorType = response.data
          })
      }
    },


    manageDates(index, date) {
      this.checkDates(index, date)
      if (date === 'debut') {
        this.checkDates(index, 'fin')
      }
    },

    checkDates(index, date) {
      this.form.abonnements.forEach(abonnement => {
        if (this.form.abonnements.indexOf(abonnement) !== index) {
          // La date saisie est comprise dans un abonnement déjà saisi
          if ((new Date(this.form.abonnements[index][date].value) > new Date(abonnement.debut.value)) && (new Date(this.form.abonnements[index][date].value) < new Date(abonnement.fin.value))) {
            this.form.abonnements[index][date].state = false
            this.form.abonnements[index][date].invalidFeedback = this.$i18n.t('abonnement.date.incorrecte')
          } else {
            this.form.abonnements[index][date].state = null
            this.form.abonnements[index][date].invalidFeedback = null
          }
          // L'abonnement saisi contient un abonnement déjà saisi
          if (this.form.abonnements[index].debut.value && this.form.abonnements[index].fin.value) {
            if (((new Date(this.form.abonnements[index].debut.value) < new Date(abonnement.debut.value)) && (new Date(this.form.abonnements[index].fin.value) > new Date(abonnement.debut.value))) || (new Date(this.form.abonnements[index].debut.value) < new Date(abonnement.fin.value)) && (new Date(this.form.abonnements[index].fin.value) > new Date(abonnement.fin.value))) {
              this.form.abonnements[index].debut.state = false
              this.form.abonnements[index].debut.invalidFeedback = this.$i18n.t('abonnement.inclus.error')
              this.form.abonnements[index].fin.state = false
              this.form.abonnements[index].fin.invalidFeedback = this.$i18n.t('abonnement.inclus.error')
            } else {
              this.form.abonnements[index].debut.state = null
              this.form.abonnements[index].debut.invalidFeedback = null
              this.form.abonnements[index].fin.state = null
              this.form.abonnements[index].fin.invalidFeedback = null
            }
          }
        }
      })
    },

    addAbonnement() {
      this.displayWarning = false
      this.form.abonnements.push({
        debut:
          {
            state: null,
            value: null,
            invalidFeedback: null
          },
        fin:
          {
            state: null,
            value: null,
            invalidFeedback: null,
          },
        abonnementPremiumType: {
          state: null,
          value: null,
          maxNbCollaborators: null,
          maxNbLots: null,
          invalidFeedback: null,
        },
        maxNbCollaborators: {
          state: null,
          value: null,
          invalidFeedback: null,
        },
        maxNbLots: {
          state: null,
          value: null,
          invalidFeedback: null,
        },
      })
    },

    clickOnDeleteBtnAbonnement(index) {
      this.form.abonnements.splice(index, 1)
    },

    async checkIfCanCreateNewUser() {
      try {
        const response = await api.get('/user/checkIfCanCreateNewUser');
        return response.data.canCreate;
      } catch (error) {
        return false;
      }
    },


    async onSubmit(e) {

      if (this.isEstateAgent && (this.form.typeCollaborator.value === "ROLE_COLLABORATOR" || this.form.typeCollaborator.value === "ROLE_COLLABORATOR_PLUS")) {
        e.preventDefault()
        const canCreate = await this.checkIfCanCreateNewUser();
        if (!canCreate) {
          this.$bvModal.msgBoxConfirm(
            this.$i18n.t('premium.no.more.user').toString(),
            {
              okTitle: this.$i18n.t('SeeSubscription'),
              cancelTitle: this.$i18n.t('Cancel'),
              centered: true,
              okVariant: 'primary',
              cancelVariant: 'secondary',
            }
          ).then((confirmed) => {
            if (confirmed) {
              this.$router.push({name: 'ProfileShow'});
            }
          });
          return
        }
      }

      if (this.form.freeAccount.value && !this.form.endAccess.value && this.isAdmin) {
        this.form.endAccess.state = false;
        this.form.endAccess.invalidFeedback = this.$i18n.t('MandatoryField');
      } else if (!this.form.freeAccount.value && this.form.abonnements.length === 0 && this.isAdmin) {
        this.displayWarning = true
      } else {
        let data = new FormData()
        data.append('firstname', this.form.firstname.value)
        data.append('lastname', this.form.lastname.value)
        data.append('username', this.form.username.value)
        data.append('phoneNumber', this.form.phoneNumber.value)
        data.append('entreprise', this.form.entreprise.value)
        data.append('address', this.form.address.value)
        data.append('postalCode', this.form.postalCode.value)
        data.append('city', this.form.city.value)
        data.append('capitalSocial', this.form.capitalSocial.value)
        data.append('siret', this.form.capitalSocial.value)
        data.append('rcs', this.form.rcs.value)
        data.append('password', this.form.password.value)
        data.append('freeAccount', this.form.freeAccount.value)
        if (this.form.endAccess.value) {
          data.append('endAccess', this.form.endAccess.value)
        }
        data.append('abonnements', JSON.stringify(this.form.abonnements))
        if (this.isEstateAgent) {
          data.append('typeCollaborator', this.form.typeCollaborator.value)
        }
        if (this.isAdmin) {
          data.append('commentaire', this.form.commentaire.value)
          data.append('virVefaEnabled', this.form.virVefaEnabled.value)
          data.append('isLNIGroup', this.form.isLNIGroup.value)
        }

        api({
          method: 'POST',
          url: `user`,
          data: data
        })
          .then(() => {
            if (this.$store.getters.isAdmin) {
              this.$router.push({
                name: 'Dashboard'
              }, () => {
                this.$nextTick(() => {
                  this.successToast(this.form.username.value)
                })
              })
            } else {
              this.$router.push({
                name: 'UserIndex'
              }, () => {
                this.$nextTick(() => {
                  this.successToast(this.form.username.value)
                })
              })
            }
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              if (this.$store.getters.isAdmin) {
                this.$router.push({
                  name: 'Dashboard'
                }, () => {
                  this.$nextTick(() => {
                    this.successToast(this.form.username.value)
                  })
                })
              } else {
                this.$router.push({
                  name: 'UserIndex'
                }, () => {
                  this.$nextTick(() => {
                    this.successToast(this.form.username.value)
                  })
                })
              }
            } else if (error.response.status === 403) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]['state'] = false
              this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
            }
          })
      }
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
      this.form[field]['invalidFeedback'] = null
    },

    successToast(userName) {
      this.$bvToast.toast((this.$store.getters.isAdmin ? this.$i18n.t('Client') : this.$i18n.t('Collaborator')) + ' "' + userName + '" ' + this.$i18n.t('added'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true
      })
    }

  }
}
</script>

<style scoped>
input::placeholder {
  opacity: 0.25;
  color: var(--main-text-color);
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserCreate.vue